<template>
  <div class="user-roles">
    <div class="user-roles__title">
      <h2>{{ $tc('role', 2) }}</h2>
      <HelperPopover template="roles-helper" />
    </div>

    <Loader :value="promise" theme="overlay">
      <Tabs
        v-model="current"
        :items="[
          { id: 'project', label: $tc('project') },
          {
            id: 'shop',
            disabled:
              access.includes('guest') ||
              !(access.includes('admin') || Boolean(itemsByRole('project.shop.manager').length)),
            label: $t('shopShort'),
          },
          {
            id: 'complaint',
            disabled: access.includes('guest'),
            label: $tc('complaint', 2),
          },
          {
            id: 'page',

            label: $tc('page', 2),
          },
        ]"
        theme="border"
        force-header
      >
        <template #project>
          <InputComponent
            v-if="!access.includes('guest') && itemsByRole('project.manager').length"
            :label="$tc('projectmanager')"
            :sublabel="$t('helpers:roleManager')"
            class="grow-1"
          >
            <template #default>
              <div class="user-mutate__scroller">
                <ChecklistComponent
                  v-model="value.project.manager"
                  :items="itemsByRole('project.manager')"
                  select-all
                  class="elder-input__element"
                />
              </div>
            </template>
          </InputComponent>

          <InputComponent
            v-if="itemsByRole('project.salesman').length"
            :label="$tc('customermanager')"
            :sublabel="$t('helpers:roleSalesman')"
            class="grow-1"
          >
            <template #default>
              <div class="user-mutate__scroller">
                <ChecklistComponent
                  v-model="value.project.salesman"
                  :items="itemsByRole('project.salesman')"
                  select-all
                  class="elder-input__element"
                />
              </div>
            </template>
          </InputComponent>

          <InputComponent
            v-if="!access.includes('guest') && itemsByRole('project.signingAuthority').length"
            :label="$tc('signingAuthority')"
            :sublabel="$t('helpers:roleSigningAuthority')"
            class="grow-1"
          >
            <template #default>
              <div class="user-mutate__scroller">
                <ChecklistComponent
                  v-model="value.project.signingAuthority"
                  :items="itemsByRole('project.signingAuthority')"
                  select-all
                  class="elder-input__element"
                />
              </div>
            </template>
          </InputComponent>
        </template>
        <template #shop>
          <InputComponent
            v-if="!access.includes('guest') && itemsByRole('project.shop.manager').length"
            :label="$tc('projectmanager')"
            :sublabel="$t('helpers:roleShopManager')"
            class="grow-1"
          >
            <template #default>
              <div class="user-mutate__scroller">
                <ChecklistComponent
                  v-model="value.project.shop.manager"
                  :items="itemsByRole('project.shop.manager')"
                  select-all
                  class="elder-input__element"
                />
              </div>
            </template>
          </InputComponent>

          <InputComponent
            v-if="itemsByRole('project.shop.salesman').length"
            :label="$tc('customermanager')"
            :sublabel="$t('helpers:roleShopSalesman')"
            class="grow-1"
          >
            <template #default>
              <div class="user-mutate__scroller">
                <ChecklistComponent
                  v-model="value.project.shop.salesman"
                  :items="itemsByRole('project.shop.salesman')"
                  select-all
                  class="elder-input__element"
                />
              </div>
            </template>
          </InputComponent>

          <InputComponent
            v-if="!access.includes('guest') && itemsByRole('project.shop.signingAuthority').length"
            :label="$tc('signingAuthority')"
            :sublabel="$t('helpers:roleShopSigningAuthority')"
            class="grow-1"
          >
            <template #default>
              <div class="user-mutate__scroller">
                <ChecklistComponent
                  v-model="value.project.shop.signingAuthority"
                  :items="itemsByRole('project.shop.signingAuthority')"
                  select-all
                  class="elder-input__element"
                />
              </div>
            </template>
          </InputComponent>
        </template>
        <template #complaint>
          <InputComponent
            v-if="!access.includes('guest') && itemsByRole('project.complaint.manager').length"
            :label="$tc('complaintmanager')"
            :sublabel="$t('helpers:roleComplaintManager')"
            class="grow-1"
          >
            <template #default>
              <div class="user-mutate__scroller">
                <ChecklistComponent
                  v-model="value.project.complaint.manager"
                  :items="itemsByRole('project.complaint.manager')"
                  select-all
                  class="elder-input__element"
                />
              </div>
            </template>
          </InputComponent>
        </template>
        <template #page>
          <InputComponent
            v-if="!access.includes('guest') && itemsByRole('page.manager').length"
            :label="$tc('usersWithAccess')"
            :sublabel="$t('canEdit')"
            class="grow-1"
          >
            <template #default>
              <div class="user-mutate__scroller">
                <ChecklistComponent
                  v-model="value.page.manager"
                  :items="itemsByRole('page.manager')"
                  select-all
                  class="elder-input__element"
                />
              </div>
            </template>
          </InputComponent>
          <InputComponent
            v-if="itemsByRole('page.salesman').length"
            :label="$tc('customermanager')"
            :sublabel="$t('helpers:roleSalesman')"
            class="grow-1"
          >
            <template #default>
              <div class="user-mutate__scroller">
                <ChecklistComponent
                  v-model="value.page.salesman"
                  :items="itemsByRole('page.salesman')"
                  select-all
                  class="elder-input__element"
                />
              </div>
            </template>
          </InputComponent>
        </template>
      </Tabs>
    </Loader>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import GraphQL from '@/api/graphql'
import RolesResources from '@/api/graphql/queries/RolesResources.gql'

import { InputComponent } from 'vue-elder-input'
import ChecklistComponent from '@/components/Select/Checklist'
import Tabs from '@/components/Tabs'
import HelperPopover from '@/components/HelperPopover/Component'
import { Languages } from '@/components/User/Language'

export default {
  props: {
    value: Object,
    access: Array,
  },
  data() {
    return {
      resources: {
        Projects: [],
        Pages: [],
      },
      promise: null,
      current: 'project',
    }
  },
  computed: {
    ...mapState(['enums']),
    defaultLanguage() {
      return (this.$path('$store.state.enums.Languages') || []).find(i => i.default) || {}
    },
  },
  methods: {
    fetchProjects() {
      this.promise = GraphQL.request(RolesResources).then(data => (this.resources = data))
    },
    getLangFlag(lang) {
      if (lang === this.defaultLanguage.value) return
      return { alt: Languages[lang], src: `/images/flags/${lang}.svg`, width: 15 }
    },
    itemsByRole(value) {
      const items = {
        'project.salesman': this.resources.Projects,
        'project.manager': this.resources.Projects,
        'project.signingAuthority': this.resources.Projects.filter(i =>
          ['project:bid', 'project:purchase'].some(e => i.metadata.addons.includes(e)),
        ),
        'project.shop.salesman': this.resources.Projects.filter(i => i.metadata.addons.includes('project:shop')),
        'project.shop.manager': this.resources.Projects.filter(i => i.metadata.addons.includes('project:shop')),
        'project.shop.signingAuthority': this.resources.Projects.filter(i =>
          i.metadata.addons.includes('project:shop-purchase'),
        ),
        'project.complaint.manager': this.resources.Projects.filter(i =>
          i.metadata.addons.includes('project:complaint'),
        ),
        'page.manager': this.resources.Pages,
        'page.salesman': this.resources.Pages,
      }
      const result = items[value]
      if (!result) return []

      return result.map(i => ({ ...i, icon: this.getLangFlag(i.metadata.language) }))
    },
  },
  created() {
    this.fetchProjects()
  },
  components: {
    Tabs,
    InputComponent,
    HelperPopover,
    ChecklistComponent,
  },
}
</script>

<style lang="scss">
.user-roles {
  &__title {
    display: flex;
    gap: 0.5rem;
  }
  & > .elder-input__wrapper > .elder-input__field {
    border: none;
  }

  .tabs__tab {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
  }
  .elder-checkbox__label {
    display: flex;
  }
}
</style>
